import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { MatNativeDateModule } from '@angular/material/core';
import { RECAPTCHA_LANGUAGE } from 'ng-recaptcha-2';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { registerIonicIcons } from './app/ionic-icons';
import { HttpConfigInterceptor } from './app/providers/httpConfig.interceptor';

if (environment.production) {
  enableProdMode();
}

registerIonicIcons();

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),provideIonicAngular(),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        importProvidersFrom(IonicStorageModule.forRoot(), MatNativeDateModule),
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        {
            provide: RECAPTCHA_LANGUAGE,
            useValue: 'en',
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
});
